import React from "react";
import styles from "./style.module.scss";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBListGroup,
  MDBListGroupItem,
  MDBAnimation
} from "mdbreact";
// import { URL_DOWNLOAD_ANDROID, URL_DOWNLOAD_IOS } from "~/configs/envs/index";
import LazyLoad from "react-lazyload";
import cx from "classnames";
import { Link } from "react-router-dom";
// import logo_f from "~/assets/img/mobile/logo/logo_f.svg";
import bocongthuong1 from "~/assets/img/mobile/logo/bocongthuong1.svg";
import bocongthuong2 from "~/assets/img/mobile/logo/bocongthuong2.svg";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";
import AppId from "~/utils/partner";
import { urlLogoHeader } from "~/utils/manageResource";

const info = get(partnerInfo, "info");
const nameInfo = find(info, { key: "name" });
const addressInfo = find(info, { key: "address" });
const websiteInfo = find(info, { key: "website" });
const emailInfo = find(info, { key: "email" });
const phoneInfo = find(info, { key: "phone" });

const Footer = props => {
  return (
    <MDBAnimation type="fadeIn" className={styles.footer}>
      <div className={styles.footer_inner}>
        <MDBContainer>
          <MDBRow>
            <MDBCol lg="2">
              <div className={styles.footer_item}>
                <Link to="/">
                  <LazyLoad height={43}>
                    <img
                      src={urlLogoHeader}
                      className="img-fluid"
                      alt=""
                      style={{ width: "250px" }}
                    />
                  </LazyLoad>
                </Link>
              </div>
            </MDBCol>
            <MDBCol lg="5">
              <div className={styles.footer_item}>
                <MDBListGroup className={styles.item_info}>
                  {AppId === "medpro" && (
                    <MDBListGroupItem>
                      <Link to="/" className={styles.textPKH}>
                        <strong>{`${nameInfo.value}`.toUpperCase()}</strong>
                      </Link>
                    </MDBListGroupItem>
                  )}
                  <MDBListGroupItem>
                    <Link to="/">
                      {`${addressInfo.displayPrefix} ${addressInfo.value}`}
                    </Link>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <Link to="/">{`${websiteInfo.displayPrefix} ${websiteInfo.value}`}</Link>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <Link to="/">{`${emailInfo.displayPrefix} ${emailInfo.value}`}</Link>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <Link to="/">
                      {`${phoneInfo.displayPrefix} ${phoneInfo.value}`}
                    </Link>
                  </MDBListGroupItem>
                </MDBListGroup>
              </div>
            </MDBCol>
            <MDBCol lg="3">
              <div className={styles.footer_item}>
                <MDBListGroup className={cx(styles.item_info, styles.icons)}>
                  <MDBListGroupItem>
                    <a
                      href="http://online.gov.vn/Home/WebDetails/44668"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Bộ công thương"
                    >
                      <LazyLoad height={50}>
                        <img src={bocongthuong1} alt="" />
                      </LazyLoad>
                    </a>
                  </MDBListGroupItem>
                  <MDBListGroupItem>
                    <a
                      href="http://online.gov.vn/Home/WebDetails/44209"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Bộ công thương"
                    >
                      <LazyLoad height={50}>
                        <img src={bocongthuong2} alt="" />
                      </LazyLoad>
                    </a>
                  </MDBListGroupItem>
                </MDBListGroup>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
      <div className={styles.footer_copy_right}>
        <MDBContainer>
          <MDBRow>
            <MDBCol size="12">
              <div className={styles.footer_item}>
                © 2020 - Bản quyền thuộc Công Ty Cổ Phần Ứng Dụng PKH
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </MDBAnimation>
  );
};

export default Footer;
